import React from 'react'


const Navigation = React.memo(function Navigation({
  icon: Icon,
  label,
  isActive = false,
  onClick = () => {},
  badge = null,
  collapsed = false,
  className = '',
  ariaLabel = undefined,
}) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick(e)
    }
  }

  return (
    <button
      type="button"
      role="button"
      aria-pressed={isActive}
      aria-label={collapsed ? ariaLabel ?? label : undefined}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className={`relative flex items-center gap-3 w-full text-left mt-3 px-3 py-2 rounded-lg transition-all ${
        isActive ? 'bg-stone-100 shadow-sm' : 'hover:bg-stone-50'
      } focus:outline-none focus-visible:ring-2 focus-visible:ring-stone-200 ${className}`}
    >
      {/* left indicator */}
      <span
        aria-hidden="true"
        className={`absolute left-0 top-1/2 -translate-y-1/2 h-8 w-1 rounded-r-md ${
          isActive ? 'bg-[#48CFCB]' : 'bg-transparent'
        }`}
      />

      {/* content (icon + label + badge) */}
      <div className={`flex items-center gap-3 w-full ${collapsed ? 'justify-center' : ''}`}>
        <Icon className="w-5 h-5 text-[#222731]" aria-hidden="true" />

        {!collapsed && (
          <span className="text-[#222731] font-medium truncate">{label}</span>
        )}

        {badge != null && (
          <span className="ml-auto text-xs font-semibold bg-stone-100 border border-stone-200 px-2 py-0.5 rounded-full text-stone-700">
            {badge}
          </span>
        )}
      </div>
    </button>
  )
})

Navigation.displayName = 'Navigation'

export default Navigation
